<app-nav-steps></app-nav-steps>
<ng-container *ngIf="!environmentService.isDecommissioningOfGridConnection || currentSelectionType !== 'shutdown'">
  <div class="component-container">
    <div class="form-font-size">
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
        <app-section-header
          [title]="'app.navigation.doc_upload' | translate | uppercase"
          [tooltip]="'tooltips.documents-submission.document-header-info' | translate"
          [showTooltip]="
            environmentService.showDocumentHeaderHintIcon && currentInstallationFlow === installationFlowType.MainsConnection
          "></app-section-header>
        <div
          [formGroup]="documents"
          *ngIf="documents || this.isGridCompatibility"
          class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12">
          <div class="form-background top-bottom-margin" *ngIf="currentInstallationFlow === installationFlowType.FeedInSystem">
            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows" *ngIf="documents.get('site_plan')">
              <label
                class="ui-g-3 field-label text-right-align"
                [class.required]="documents.get('site_plan')?.validator"
                for="official-plan">
                {{ showSitePlanLabel ? ('documents.site-plan' | translate) : ('documents.official-plan' | translate) }}
              </label>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                <input class="doc-submit-inputs" id="official-plan" pInputText type="text" formControlName="site_plan" />
              </div>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                <p-fileUpload
                  #documentUploader0
                  chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                  (onSelect)="onSelectFile($event, documentTypes[0].value, documentUploader0, 'site_plan')"
                  mode="basic"></p-fileUpload>
              </div>
              <div class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align">
                <!-- <i class="pi pi-info-circle hint-icon" *ngIf="infoBubblesData?.showSitePlanInfo"></i> -->
              </div>
            </div>
            <div *ngIf="documents.get('site_plan') && allSampleDocuments?.site_plan" class="ui-g-12 sample-doc-link">
              <label class="ui-g-3"></label>
              <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
              <a (click)="downloadExampleDocument(allSampleDocuments['site_plan'].document_id, allSampleDocuments['site_plan'].filename)">
                {{ allSampleDocuments['site_plan'].name }}
              </a>
            </div>
            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows" *ngIf="documents.get('unit_certificate')">
              <label class="ui-g-3 field-label text-right-align" for="unit-certificate" [class.required]="requiredUnitCertificateDocument">
                {{ 'documents.unit-certificate' | translate }}
              </label>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                <input class="doc-submit-inputs" id="unit-certificate" pInputText type="text" formControlName="unit_certificate" />
              </div>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                <p-fileUpload
                  #documentUploader1
                  chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                  (onSelect)="onSelectFile($event, documentTypes[2].value, documentUploader1, 'unit_certificate')"
                  mode="basic"></p-fileUpload>
              </div>
              <div class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align">
                <!-- <i class="pi pi-info-circle hint-icon" *ngIf="infoBubblesData?.showUnitCertificateInfo"></i> -->
              </div>
            </div>
            <div *ngIf="allSampleDocuments?.unit_certificate" class="ui-g-12 sample-doc-link">
              <label class="ui-g-3"></label>
              <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
              <a
                (click)="
                  downloadExampleDocument(
                    allSampleDocuments['unit_certificate'].document_id,
                    allSampleDocuments['unit_certificate'].filename
                  )
                ">
                {{ allSampleDocuments['unit_certificate'].name }}
              </a>
            </div>
            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows" *ngIf="documents.get('na_protection_certificate')">
              <label
                class="ui-g-3 field-label text-right-align"
                for="protection-certificate"
                [class.required]="requiredNaProtectionCertificateDocument">
                {{ 'documents.protection-certificate' | translate }}
              </label>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                <input
                  class="doc-submit-inputs"
                  id="protection-certificate"
                  pInputText
                  type="text"
                  formControlName="na_protection_certificate" />
              </div>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                <p-fileUpload
                  #documentUploader2
                  chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                  (onSelect)="onSelectFile($event, documentTypes[3].value, documentUploader2, 'na_protection_certificate')"
                  mode="basic"></p-fileUpload>
              </div>
              <div class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align">
                <!-- <i class="pi pi-info-circle hint-icon" *ngIf="infoBubblesData?.showProtectionCertificateInfo"></i> -->
              </div>
            </div>
            <div *ngIf="allSampleDocuments?.na_protection_certificate" class="ui-g-12 sample-doc-link">
              <label class="ui-g-3"></label>
              <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
              <a
                (click)="
                  downloadExampleDocument(
                    allSampleDocuments['na_protection_certificate'].document_id,
                    allSampleDocuments['na_protection_certificate'].name
                  )
                ">
                {{ allSampleDocuments['na_protection_certificate'].filename }}
              </a>
            </div>
            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows" *ngIf="documents.get('vde_documents')">
              <label class="ui-g-3 field-label text-right-align" for="vde-document" [class.required]="requiredVdeDocument">
                {{ 'documents.vde-document' | translate }}
              </label>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                <input class="doc-submit-inputs" id="vde-document" pInputText type="text" formControlName="vde_documents" />
              </div>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                <p-fileUpload
                  #documentUploader3
                  chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                  (onSelect)="onSelectFile($event, documentTypes[4].value, documentUploader3, 'vde_documents')"
                  mode="basic"></p-fileUpload>
              </div>
              <div class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align">
                <!-- <i class="pi pi-info-circle hint-icon" *ngIf="infoBubblesData?.showVDEDocumentInfo"></i> -->
              </div>
            </div>
            <div *ngIf="allSampleDocuments?.vde_documents" class="ui-g-12 sample-doc-link">
              <label class="ui-g-3"></label>
              <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
              <a
                (click)="
                  downloadExampleDocument(allSampleDocuments['vde_documents'].document_id, allSampleDocuments['vde_documents'].filename)
                ">
                {{ allSampleDocuments['vde_documents'].name }}
              </a>
            </div>
            <div *ngIf="documents.get('data_sheet_modules')" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
              <label class="ui-g-3 field-label text-right-align required" for="manufacturer-sheets">
                {{ 'documents.manufacturer-sheets' | translate }}
              </label>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                <input class="doc-submit-inputs" id="manufacturer-sheets" pInputText type="text" formControlName="data_sheet_modules" />
              </div>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                <p-fileUpload
                  #documentUploader4
                  chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                  (onSelect)="onSelectFile($event, documentTypes[5].value, documentUploader4, 'data_sheet_modules')"
                  mode="basic"></p-fileUpload>
              </div>
              <div class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align">
                <!-- <i class="pi pi-info-circle hint-icon" *ngIf="infoBubblesData?.showManufacturerSheetsInfo"></i> -->
              </div>
            </div>
            <div *ngIf="allSampleDocuments?.data_sheet_modules" class="ui-g-12 sample-doc-link">
              <label class="ui-g-3"></label>
              <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
              <a
                (click)="
                  downloadExampleDocument(
                    allSampleDocuments['data_sheet_modules'].document_id,
                    allSampleDocuments['data_sheet_modules'].filename
                  )
                ">
                {{ allSampleDocuments['data_sheet_modules'].name }}
              </a>
            </div>
            <div *ngIf="documents.get('data_sheet_generating_unit')" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
              <label class="ui-g-3 field-label text-right-align required" for="manufacturer-generation-sheet">
                {{ 'documents.manufacturer-generation-sheet' | translate }}
              </label>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                <input
                  class="doc-submit-inputs"
                  id="manufacturer-generation-sheet"
                  pInputText
                  type="text"
                  formControlName="data_sheet_generating_unit" />
              </div>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                <p-fileUpload
                  #documentUploader5
                  chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                  (onSelect)="onSelectFile($event, documentTypes[6].value, documentUploader5, 'data_sheet_generating_unit')"
                  mode="basic"></p-fileUpload>
              </div>
              <div class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align">
                <!-- <i class="pi pi-info-circle hint-icon" *ngIf="infoBubblesData?.showManufacturerGenSheetsInfo"></i> -->
              </div>
            </div>
            <div *ngIf="allSampleDocuments?.data_sheet_generating_unit" class="ui-g-12 sample-doc-link">
              <label class="ui-g-3"></label>
              <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
              <a
                (click)="
                  downloadExampleDocument(
                    allSampleDocuments['data_sheet_generating_unit'].document_id,
                    allSampleDocuments['data_sheet_generating_unit'].filename
                  )
                ">
                {{ allSampleDocuments['data_sheet_generating_unit'].name }}
              </a>
            </div>
            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows" *ngIf="documents.get('overview_plan_single_pole')">
              <label
                class="ui-g-3 field-label text-right-align"
                for="single-pole-overview-plan"
                [class.required]="requiredOverviewPlanSinglePoleDocument">
                {{ 'documents.single-pole-overview-plan' | translate }}
              </label>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                <input
                  class="doc-submit-inputs"
                  id="single-pole-overview-plan"
                  pInputText
                  type="text"
                  formControlName="overview_plan_single_pole" />
              </div>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                <p-fileUpload
                  #documentUploader6
                  chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                  (onSelect)="onSelectFile($event, documentTypes[7].value, documentUploader6, 'overview_plan_single_pole')"
                  mode="basic"></p-fileUpload>
              </div>
              <div class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align">
                <!-- <i class="pi pi-info-circle hint-icon" *ngIf="infoBubblesData?.showSinglePoleOverviewPlanInfo"></i> -->
              </div>
            </div>
            <div *ngIf="allSampleDocuments?.overview_plan_single_pole" class="ui-g-12 sample-doc-link">
              <label class="ui-g-3"></label>
              <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
              <a
                (click)="
                  downloadExampleDocument(
                    allSampleDocuments['overview_plan_single_pole'].document_id,
                    allSampleDocuments['overview_plan_single_pole'].filename
                  )
                ">
                {{ allSampleDocuments['overview_plan_single_pole'].name }}
              </a>
            </div>
            <div *ngIf="documents.get('pole_circuit_diagram_1')" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
              <label class="ui-g-3 field-label text-right-align required" for="single-pole-overview-plan">
                {{ 'lookup.' + documentTypeKey + '.options.pole_circuit_diagram_1.name' | translate }}
              </label>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                <input
                  class="doc-submit-inputs"
                  id="1-pole-circuit-diagram"
                  pInputText
                  type="text"
                  formControlName="pole_circuit_diagram_1" />
              </div>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                <p-fileUpload
                  #documentUploader7
                  chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                  (onSelect)="onSelectFile($event, documentTypes[11].value, documentUploader7, 'pole_circuit_diagram_1')"
                  mode="basic"></p-fileUpload>
              </div>
              <div class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align">
                <!-- <i class="pi pi-info-circle hint-icon" *ngIf="infoBubblesData?.showSinglePoleCircuitDiagramInfo"></i> -->
              </div>
            </div>

            <!-- power_of_attorney_1 -->
            <div *ngIf="documents.get('power_of_attorney_1')" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
              <label
                [ngClass]="{ required: required.power_of_attorney_1 }"
                class="ui-g-3 field-label text-right-align required"
                for="power_of_attorney_1">
                {{ 'documents.power_of_attorney_1' | translate }}
              </label>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                <input class="doc-submit-inputs" id="power_of_attorney_1" pInputText type="text" formControlName="power_of_attorney_1" />
              </div>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                <p-fileUpload
                  #power_of_attorney_1_uploader
                  chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                  (onSelect)="onSelectFile($event, 'power_of_attorney_1', power_of_attorney_1_uploader, 'power_of_attorney_1')"
                  mode="basic"></p-fileUpload>
              </div>
              <div class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align">
                <app-tooltip [textKey]="'documents.power_of_attorney_1_info' | translate"></app-tooltip>
              </div>
            </div>

            <div *ngIf="allSampleDocuments?.power_of_attorney_1" class="ui-g-12 sample-doc-link">
              <label class="ui-g-3"></label>
              <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
              <a
                (click)="
                  downloadExampleDocument(
                    allSampleDocuments['power_of_attorney_1'].document_id,
                    allSampleDocuments['power_of_attorney_1'].filename
                  )
                ">
                {{ allSampleDocuments['power_of_attorney_1'].name }}
              </a>
            </div>

            <!-- e_1_application -->
            <div *ngIf="documents.get('e_1_application')" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
              <label
                [ngClass]="{ required: required.e_1_application }"
                class="ui-g-3 field-label text-right-align required"
                for="e_1_application">
                {{ 'documents.e_1_application' | translate }}
              </label>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                <input class="doc-submit-inputs" id="e_1_application" pInputText type="text" formControlName="e_1_application" />
              </div>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                <p-fileUpload
                  #e_1_application_uploader
                  chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                  (onSelect)="onSelectFile($event, 'e_1_application', e_1_application_uploader, 'e_1_application')"
                  mode="basic"></p-fileUpload>
              </div>
              <div class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align">
                <app-tooltip [textKey]="'documents.e_1_application_info' | translate"></app-tooltip>
              </div>
            </div>

            <!-- e_2_data_sheet -->
            <div *ngIf="documents.get('e_2_data_sheet')" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
              <label
                [ngClass]="{ required: required.e_2_data_sheet }"
                class="ui-g-3 field-label text-right-align required"
                for="e_2_data_sheet">
                {{ 'documents.e_2_data_sheet' | translate }}
              </label>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                <input class="doc-submit-inputs" id="e_2_data_sheet" pInputText type="text" formControlName="e_2_data_sheet" />
              </div>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                <p-fileUpload
                  #e_2_data_sheet_uploader
                  chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                  (onSelect)="onSelectFile($event, 'e_2_data_sheet', e_2_data_sheet_uploader, 'e_2_data_sheet')"
                  mode="basic"></p-fileUpload>
              </div>
              <div class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align">
                <app-tooltip [textKey]="'documents.e_2_data_sheet_info' | translate"></app-tooltip>
              </div>
            </div>

            <!-- e_3_memory_data -->
            <div *ngIf="documents.get('e_3_memory_data')" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
              <label
                [ngClass]="{ required: required.e_3_memory_data }"
                class="ui-g-3 field-label text-right-align required"
                for="e_3_memory_data">
                {{ 'documents.e_3_memory_data' | translate }}
              </label>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                <input class="doc-submit-inputs" id="e_3_memory_data" pInputText type="text" formControlName="e_3_memory_data" />
              </div>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                <p-fileUpload
                  #e_3_memory_data_uploader
                  chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                  (onSelect)="onSelectFile($event, 'e_3_memory_data', e_3_memory_data_uploader, 'e_3_memory_data')"
                  mode="basic"></p-fileUpload>
              </div>
              <div class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align">
                <app-tooltip [textKey]="'documents.e_3_memory_data_info' | translate"></app-tooltip>
              </div>
            </div>

            <!-- e_4_uniform_certificate -->
            <div *ngIf="documents.get('e_4_uniform_certificate')" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
              <label
                [ngClass]="{ required: required.e_4_uniform_certificate }"
                class="ui-g-3 field-label text-right-align required"
                for="e_4_uniform_certificate">
                {{ 'documents.e_4_uniform_certificate' | translate }}
              </label>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                <input
                  class="doc-submit-inputs"
                  id="e_4_uniform_certificate"
                  pInputText
                  type="text"
                  formControlName="e_4_uniform_certificate" />
              </div>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                <p-fileUpload
                  #e_4_uniform_certificate_uploader
                  chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                  (onSelect)="onSelectFile($event, 'e_4_uniform_certificate', e_4_uniform_certificate_uploader, 'e_4_uniform_certificate')"
                  mode="basic"></p-fileUpload>
              </div>
              <div class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align">
                <app-tooltip [textKey]="'documents.e_4_uniform_certificate_info' | translate"></app-tooltip>
              </div>
            </div>

            <!-- e_5_test_report -->
            <div *ngIf="documents.get('e_5_test_report')" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
              <label
                [ngClass]="{ required: required.e_5_test_report }"
                class="ui-g-3 field-label text-right-align required"
                for="e_5_test_report">
                {{ 'documents.e_5_test_report' | translate }}
              </label>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                <input class="doc-submit-inputs" id="e_5_test_report" pInputText type="text" formControlName="e_5_test_report" />
              </div>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                <p-fileUpload
                  #e_5_test_report_uploader
                  chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                  (onSelect)="onSelectFile($event, 'e_5_test_report', e_5_test_report_uploader, 'e_5_test_report')"
                  mode="basic"></p-fileUpload>
              </div>
              <div class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align">
                <app-tooltip [textKey]="'documents.e_5_test_report_info' | translate"></app-tooltip>
              </div>
            </div>

            <!-- e_6_certificate_for_network -->
            <div
              *ngIf="documents.get('e_6_certificate_for_network')"
              class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
              <label
                [ngClass]="{ required: required.e_6_certificate_for_network }"
                class="ui-g-3 field-label text-right-align required"
                for="e_6_certificate_for_network">
                {{ 'documents.e_6_certificate_for_network' | translate }}
              </label>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                <input
                  class="doc-submit-inputs"
                  id="e_6_certificate_for_network"
                  pInputText
                  type="text"
                  formControlName="e_6_certificate_for_network" />
              </div>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                <p-fileUpload
                  #e_6_certificate_for_network_uploader
                  chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                  (onSelect)="
                    onSelectFile($event, 'e_6_certificate_for_network', e_6_certificate_for_network_uploader, 'e_6_certificate_for_network')
                  "
                  mode="basic"></p-fileUpload>
              </div>
              <div class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align">
                <app-tooltip [textKey]="'documents.e_6_certificate_for_network_info' | translate"></app-tooltip>
              </div>
            </div>

            <!-- e_7_requirements_for_test_report -->
            <div
              *ngIf="documents.get('e_7_requirements_for_test_report')"
              class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
              <label
                [ngClass]="{ required: required.e_7_requirements_for_test_report }"
                class="ui-g-3 field-label text-right-align required"
                for="e_7_requirements_for_test_report">
                {{ 'documents.e_7_requirements_for_test_report' | translate }}
              </label>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                <input
                  class="doc-submit-inputs"
                  id="e_7_requirements_for_test_report"
                  pInputText
                  type="text"
                  formControlName="e_7_requirements_for_test_report" />
              </div>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                <p-fileUpload
                  #e_7_requirements_for_test_report_uploader
                  chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                  (onSelect)="
                    onSelectFile(
                      $event,
                      'e_7_requirements_for_test_report',
                      e_7_requirements_for_test_report_uploader,
                      'e_7_requirements_for_test_report'
                    )
                  "
                  mode="basic"></p-fileUpload>
              </div>
              <div class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align">
                <app-tooltip [textKey]="'documents.e_7_requirements_for_test_report_info' | translate"></app-tooltip>
              </div>
            </div>

            <!-- e_8_commissioning_protocol -->
            <div *ngIf="documents.get('e_8_commissioning_protocol')" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
              <label
                [ngClass]="{ required: required.e_8_commissioning_protocol }"
                class="ui-g-3 field-label text-right-align required"
                for="e_8_commissioning_protocol">
                {{ 'documents.e_8_commissioning_protocol' | translate }}
              </label>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                <input
                  class="doc-submit-inputs"
                  id="e_8_commissioning_protocol"
                  pInputText
                  type="text"
                  formControlName="e_8_commissioning_protocol" />
              </div>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                <p-fileUpload
                  #e_8_commissioning_protocol_uploader
                  chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                  (onSelect)="
                    onSelectFile($event, 'e_8_commissioning_protocol', e_8_commissioning_protocol_uploader, 'e_8_commissioning_protocol')
                  "
                  mode="basic"></p-fileUpload>
              </div>
              <div class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align">
                <app-tooltip [textKey]="'documents.e_8_commissioning_protocol_info' | translate"></app-tooltip>
              </div>
            </div>

            <!-- b_11_overview_circuit_diagram -->
            <div
              *ngIf="documents.get('b_11_overview_circuit_diagram')"
              class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
              <label
                [ngClass]="{ required: required.b_11_overview_circuit_diagram }"
                class="ui-g-3 field-label text-right-align required"
                for="b_11_overview_circuit_diagram">
                {{ 'documents.b_11_overview_circuit_diagram' | translate }}
              </label>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                <input
                  class="doc-submit-inputs"
                  id="b_11_overview_circuit_diagram"
                  pInputText
                  type="text"
                  formControlName="b_11_overview_circuit_diagram" />
              </div>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                <p-fileUpload
                  #b_11_overview_circuit_diagram_uploader
                  chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                  (onSelect)="
                    onSelectFile(
                      $event,
                      'b_11_overview_circuit_diagram',
                      b_11_overview_circuit_diagram_uploader,
                      'b_11_overview_circuit_diagram'
                    )
                  "
                  mode="basic"></p-fileUpload>
              </div>
              <div class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align">
                <app-tooltip [textKey]="'documents.b_11_overview_circuit_diagram_info' | translate"></app-tooltip>
              </div>
            </div>

            <!-- registration_for_network_connection -->
            <div
              *ngIf="documents.get('registration_for_network_connection')"
              class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
              <label
                [ngClass]="{ required: required.registration_for_network_connection }"
                class="ui-g-3 field-label text-right-align required"
                for="registration_for_network_connection">
                {{ 'documents.registration_for_network_connection' | translate }}
              </label>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                <input
                  class="doc-submit-inputs"
                  id="registration_for_network_connection"
                  pInputText
                  type="text"
                  formControlName="registration_for_network_connection" />
              </div>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                <p-fileUpload
                  #registration_for_network_connection_uploader
                  chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                  (onSelect)="
                    onSelectFile(
                      $event,
                      'registration_for_network_connection',
                      registration_for_network_connection_uploader,
                      'registration_for_network_connection'
                    )
                  "
                  mode="basic"></p-fileUpload>
              </div>
              <div class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align">
                <app-tooltip [textKey]="'documents.registration_for_network_connection_info' | translate"></app-tooltip>
              </div>
            </div>

            <!-- site_plan_or_area_map -->
            <div *ngIf="documents.get('site_plan_or_area_map')" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
              <label
                [ngClass]="{ required: required.site_plan_or_area_map }"
                class="ui-g-3 field-label text-right-align required"
                for="site_plan_or_area_map">
                {{ 'documents.site_plan_or_area_map' | translate }}
              </label>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                <input
                  class="doc-submit-inputs"
                  id="site_plan_or_area_map"
                  pInputText
                  type="text"
                  formControlName="site_plan_or_area_map" />
              </div>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                <p-fileUpload
                  #site_plan_or_area_map_uploader
                  chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                  (onSelect)="onSelectFile($event, 'site_plan_or_area_map', site_plan_or_area_map_uploader, 'site_plan_or_area_map')"
                  mode="basic"></p-fileUpload>
              </div>
              <div class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align">
                <app-tooltip [textKey]="'documents.site_plan_or_area_map_info' | translate"></app-tooltip>
              </div>
            </div>

            <!-- proof_of_conformity_certificates_modules -->
            <div
              *ngIf="documents.get('proof_of_conformity_certificates_modules')"
              class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
              <label
                [ngClass]="{ required: required.proof_of_conformity_certificates_modules }"
                class="ui-g-3 field-label text-right-align required"
                for="proof_of_conformity_certificates_modules">
                {{ 'documents.proof_of_conformity_certificates_modules' | translate }}
              </label>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                <input
                  class="doc-submit-inputs"
                  id="proof_of_conformity_certificates_modules"
                  pInputText
                  type="text"
                  formControlName="proof_of_conformity_certificates_modules" />
              </div>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                <p-fileUpload
                  #proof_of_conformity_certificates_modules_uploader
                  chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                  (onSelect)="
                    onSelectFile(
                      $event,
                      'proof_of_conformity_certificates_modules',
                      proof_of_conformity_certificates_modules_uploader,
                      'proof_of_conformity_certificates_modules'
                    )
                  "
                  mode="basic"></p-fileUpload>
              </div>
              <div class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align">
                <app-tooltip [textKey]="'documents.proof_of_conformity_certificates_modules_info' | translate"></app-tooltip>
              </div>
            </div>

            <!-- proof_of_conformity_certificates_storage -->
            <div
              *ngIf="documents.get('proof_of_conformity_certificates_storage')"
              class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
              <label
                [ngClass]="{ required: required.proof_of_conformity_certificates_storage }"
                class="ui-g-3 field-label text-right-align required"
                for="proof_of_conformity_certificates_storage">
                {{ 'documents.proof_of_conformity_certificates_storage' | translate }}
              </label>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                <input
                  class="doc-submit-inputs"
                  id="proof_of_conformity_certificates_storage"
                  pInputText
                  type="text"
                  formControlName="proof_of_conformity_certificates_storage" />
              </div>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                <p-fileUpload
                  #proof_of_conformity_certificates_storage_uploader
                  chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                  (onSelect)="
                    onSelectFile(
                      $event,
                      'proof_of_conformity_certificates_storage',
                      proof_of_conformity_certificates_storage_uploader,
                      'proof_of_conformity_certificates_storage'
                    )
                  "
                  mode="basic"></p-fileUpload>
              </div>
              <div class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align">
                <app-tooltip [textKey]="'documents.proof_of_conformity_certificates_storage_info' | translate"></app-tooltip>
              </div>
            </div>

            <!-- ground_protocol -->
            <div *ngIf="documents.get('ground_protocol')" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
              <label
                class="ui-g-3 field-label text-right-align required"
                [ngClass]="{ required: required.ground_protocol }"
                for="ground_protocol">
                {{ 'documents.ground_protocol' | translate }}
              </label>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                <input class="doc-submit-inputs" id="ground_protocol" pInputText type="text" formControlName="ground_protocol" />
              </div>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                <p-fileUpload
                  #ground_protocol_uploader
                  chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                  (onSelect)="onSelectFile($event, 'ground_protocol', ground_protocol_uploader, 'ground_protocol')"
                  mode="basic"></p-fileUpload>
              </div>
              <div class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align">
                <app-tooltip [textKey]="'documents.ground_protocol_info' | translate"></app-tooltip>
              </div>
            </div>

            <!-- measuring_concept -->
            <div *ngIf="documents.get('measuring_concept')" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
              <label
                [ngClass]="{ required: required.measuring_concept }"
                class="ui-g-3 field-label text-right-align required"
                for="measuring_concept">
                {{ 'documents.measuring_concept' | translate }}
              </label>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                <input class="doc-submit-inputs" id="measuring_concept" pInputText type="text" formControlName="measuring_concept" />
              </div>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                <p-fileUpload
                  #measuring_concept_uploader
                  chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                  (onSelect)="onSelectFile($event, 'measuring_concept', measuring_concept_uploader, 'measuring_concept')"
                  mode="basic"></p-fileUpload>
              </div>
              <div class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align">
                <app-tooltip [textKey]="'documents.measuring_concept_info' | translate"></app-tooltip>
              </div>
            </div>

            <div *ngIf="allSampleDocuments && allSampleDocuments['pole_circuit_diagram_1']" class="ui-g-12 sample-doc-link">
              <label class="ui-g-3"></label>
              <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
              <a
                (click)="
                  downloadExampleDocument(
                    allSampleDocuments['pole_circuit_diagram_1'].document_id,
                    allSampleDocuments['pole_circuit_diagram_1'].filename
                  )
                ">
                {{ allSampleDocuments['pole_circuit_diagram_1'].name }}
              </a>
            </div>
          </div>
          <div class="form-background top-bottom-margin" *ngIf="isSitePlanDocumentVisible">
            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows" *ngIf="documents.get('site_plan')">
              <label
                class="ui-g-3 field-label text-right-align"
                [class.required]="documents.get('site_plan')?.validator"
                for="official-plan">
                {{ 'documents.official-plan' | translate }}
              </label>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                <input class="doc-submit-inputs" pInputText type="text" formControlName="site_plan" />
              </div>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                <p-fileUpload
                  #documentUploader8
                  chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                  (onSelect)="onSelectFile($event, documentTypes[0].value, documentUploader8, 'site_plan')"
                  mode="basic"></p-fileUpload>
              </div>
              <div
                class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align"
                *ngIf="infoBubblesData?.showSitePlanInfo">
                <!-- <i class="pi pi-info-circle hint-icon"></i> -->
              </div>
            </div>
            <div *ngIf="documents.get('site_plan') && allSampleDocuments?.site_plan" class="ui-g-12 sample-doc-link">
              <label class="ui-g-3"></label>
              <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
              <a (click)="downloadExampleDocument(allSampleDocuments['site_plan'].document_id, allSampleDocuments['site_plan'].filename)">
                {{ allSampleDocuments['site_plan'].name }}
              </a>
            </div>

            <div
              class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows"
              *ngIf="
                documents.get('floor_plan') &&
                (currentInstallationFlow === installationFlowType.TemporaryConnection ||
                  currentInstallationFlow === installationFlowType.SiteElectricityMeterdata)
              ">
              <label
                class="ui-g-3 field-label text-right-align"
                [class.required]="documents.get('floor_plan')?.validator && floorPlanDocumentRequired"
                for="building-floor-plan">
                {{ floorPlanText | translate }}
              </label>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                <input class="doc-submit-inputs" id="building-floor-plan" pInputText type="text" formControlName="floor_plan" />
              </div>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button flex-align-center">
                <p-fileUpload
                  #documentUploader9
                  chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                  (onSelect)="onSelectFile($event, documentTypes[1].value, documentUploader9, 'floor_plan')"
                  mode="basic"></p-fileUpload>
                <div
                  class="ui-g-5 ui-xl-5 ui-lg-5 ui-md-12 ui-sm-12 ui-xs-12 info-text padding-left-1"
                  *ngIf="environmentService.showIfNecessaryInfoText">
                  {{ 'documents.floor_plan_if_necessary' | translate }}
                </div>
              </div>
              <div
                class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align"
                *ngIf="infoBubblesData?.showFloorPlanInfo">
                <!-- <i class="pi pi-info-circle hint-icon"></i> -->
              </div>
            </div>
            <div
              class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows"
              *ngIf="
                documents.get('ordnance') &&
                (currentInstallationFlow === installationFlowType.TemporaryConnection ||
                  currentInstallationFlow === installationFlowType.SiteElectricityMeterdata)
              ">
              <label class="ui-g-3 field-label text-right-align" [class.required]="documents.get('ordnance')?.validator" for="ordnance">
                {{ 'documents.ordnance' | translate }}
              </label>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                <input class="doc-submit-inputs" id="ordnance" pInputText type="text" formControlName="ordnance" />
              </div>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button flex-align-center">
                <p-fileUpload
                  #documentUploaderOrdnance
                  chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                  (onSelect)="onSelectFile($event, documentTypes[13].value, documentUploaderOrdnance, 'ordnance')"
                  mode="basic"></p-fileUpload>
              </div>
            </div>
            <div
              *ngIf="currentInstallationFlow === installationFlowType.TemporaryConnection && allSampleDocuments?.floor_plan"
              class="ui-g-12 sample-doc-link">
              <label class="ui-g-3"></label>
              <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
              <a (click)="downloadExampleDocument(allSampleDocuments['floor_plan'].document_id, allSampleDocuments['floor_plan'].filename)">
                {{ allSampleDocuments['floor_plan'].name }}
              </a>
            </div>

            <div
              class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows"
              *ngIf="isFloorPlanDocumentVisible && documents.get('floor_plan')">
              <label
                class="ui-g-3 field-label text-right-align"
                [class.required]="documents.get('floor_plan')?.validator"
                for="plan-with-entry">
                {{ 'documents.plan_with_entry' | translate }}
              </label>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                <input class="doc-submit-inputs" id="plan-with-entry" pInputText type="text" formControlName="floor_plan" />
              </div>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                <p-fileUpload
                  #documentUploader10
                  chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                  (onSelect)="onSelectFile($event, documentTypes[1].value, documentUploader10, 'floor_plan')"
                  mode="basic"></p-fileUpload>
              </div>
              <div
                class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align"
                *ngIf="infoBubblesData?.showFloorPlanInfo">
                <!-- <i class="pi pi-info-circle hint-icon"></i> -->
              </div>
            </div>
            <div
              *ngIf="
                (currentInstallationFlow === installationFlowType.MainsConnection ||
                  currentInstallationFlow === installationFlowType.ChangeHouseConnection) &&
                allSampleDocuments?.floor_plan
              "
              class="ui-g-12 sample-doc-link">
              <label class="ui-g-3"></label>
              <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
              <a (click)="downloadExampleDocument(allSampleDocuments['floor_plan'].document_id, allSampleDocuments['floor_plan'].filename)">
                {{ allSampleDocuments['floor_plan'].name }}
              </a>
            </div>

            <div
              class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows"
              *ngIf="showExcerptOrOverviewPlanDocument && currentInstallationFlow === installationFlowType.MainsConnection">
              <label
                class="ui-g-3 field-label text-right-align"
                [class.required]="documents.get('excerpt_or_overview_plan')?.validator"
                for="excerpt-or-overview-plan">
                {{ 'documents.excerpt-or-overview-plan' | translate }}
              </label>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                <input
                  class="doc-submit-inputs"
                  id="excerpt-or-overview-plan"
                  pInputText
                  type="text"
                  formControlName="excerpt_or_overview_plan" />
              </div>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                <p-fileUpload
                  #documentUploaderExcerptOrOverviewPlan
                  chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                  (onSelect)="
                    onSelectFile($event, documentTypes[14].value, documentUploaderExcerptOrOverviewPlan, 'excerpt_or_overview_plan')
                  "
                  mode="basic"></p-fileUpload>
              </div>
            </div>
            <div
              *ngIf="
                (currentInstallationFlow === installationFlowType.MainsConnection ||
                  (currentInstallationFlow === installationFlowType.ChangeHouseConnection &&
                    !environmentService.hideExampleOfDocExcerptOrOverviewPlan)) &&
                allSampleDocuments?.floor_plan
              "
              class="ui-g-12 sample-doc-link">
              <label class="ui-g-3"></label>
              <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
              <a
                (click)="
                  downloadExampleDocument(
                    allSampleDocuments['excerpt_or_overview_plan'].document_id,
                    allSampleDocuments['excerpt_or_overview_plan'].filename
                  )
                ">
                {{ allSampleDocuments['excerpt_or_overview_plan'].name }}
              </a>
            </div>

            <div
              class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows"
              *ngIf="
                (currentInstallationFlow === installationFlowType.MainsConnection ||
                  currentInstallationFlow === installationFlowType.ChangeHouseConnection) &&
                documents?.get('license_agreement')
              ">
              <label class="ui-g-3 field-label text-right-align required" for="official-plan">
                {{ 'lookup.' + documentTypeKey + '.options.license_agreement.name' | translate }}
              </label>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                <input class="doc-submit-inputs" id="license_agreement" pInputText type="text" formControlName="license_agreement" />
              </div>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                <p-fileUpload
                  #documentUploaderLicenseAgreement
                  chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                  (onSelect)="onSelectFile($event, documentTypes[15].value, documentUploaderLicenseAgreement, 'license_agreement')"
                  mode="basic"></p-fileUpload>
              </div>
            </div>
            <div
              *ngIf="
                (currentInstallationFlow === installationFlowType.MainsConnection ||
                  currentInstallationFlow === installationFlowType.ChangeHouseConnection) &&
                allSampleDocuments?.license_agreement &&
                documents?.get('license_agreement')
              "
              class="ui-g-12 sample-doc-link">
              <label class="ui-g-3"></label>
              <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
              <a
                (click)="
                  downloadExampleDocument(
                    allSampleDocuments['license_agreement'].document_id,
                    allSampleDocuments['license_agreement'].filename
                  )
                ">
                {{ allSampleDocuments['license_agreement'].name }}
              </a>
            </div>

            <ng-container *ngIf="isSiteElectricityRequired">
              <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
                <label class="ui-g-3 field-label text-right-align required" for="site-electricity-document">
                  {{ 'documents.site_electricity_document' | translate }}
                </label>
                <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                  <input
                    class="doc-submit-inputs"
                    id="site-electricity-document"
                    pInputText
                    type="text"
                    formControlName="site_electricity_document" />
                </div>
                <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                  <p-fileUpload
                    #documentUploader11
                    chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                    (onSelect)="onSelectFile($event, documentTypes[1].value, documentUploader11, 'site_electricity_document')"
                    mode="basic"></p-fileUpload>
                </div>
                <div class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align">
                  <!-- <i class="pi pi-info-circle hint-icon" *ngIf="infoBubblesData?.showSiteElectricityInfo"></i> -->
                </div>
              </div>
              <div *ngIf="allSampleDocuments?.floor_plan" class="ui-g-12 sample-doc-link">
                <label class="ui-g-3"></label>
                <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
                <a
                  (click)="
                    downloadExampleDocument(allSampleDocuments['floor_plan'].document_id, allSampleDocuments['floor_plan'].filename)
                  ">
                  {{ allSampleDocuments['floor_plan'].name }}
                </a>
              </div>
            </ng-container>

            <ng-container *ngIf="isBasementAvailable">
              <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
                <label class="ui-g-3 field-label text-right-align required" for="basement-floorplan-document">
                  {{ 'documents.floor_plan_basement' | translate }}
                </label>
                <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                  <input
                    class="doc-submit-inputs"
                    id="basement-floorplan-document"
                    pInputText
                    type="text"
                    formControlName="floor_plan_basement" />
                </div>
                <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                  <p-fileUpload
                    #documentUploader12
                    chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                    (onSelect)="onSelectFile($event, documentTypes[15].value, documentUploader12, 'floor_plan_basement')"
                    mode="basic"></p-fileUpload>
                </div>
                <div class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align">
                  <!-- <i class="pi pi-info-circle hint-icon" *ngIf="infoBubblesData?.showFloorPlanBasementInfo"></i> -->
                </div>
              </div>
              <div *ngIf="allSampleDocuments?.floor_plan_basement" class="ui-g-12 sample-doc-link">
                <label class="ui-g-3"></label>
                <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
                <a
                  (click)="
                    downloadExampleDocument(
                      allSampleDocuments['floor_plan_basement'].document_id,
                      allSampleDocuments['floor_plan_basement'].filename
                    )
                  ">
                  {{ allSampleDocuments['floor_plan_basement'].name }}
                </a>
              </div>
            </ng-container>

            <ng-container *ngIf="documents.get('drinking_water_registration')">
              <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
                <label class="ui-g-3 field-label text-right-align required" for="water-registry-document">
                  {{ 'documents.water-registry-document' | translate }}
                </label>
                <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                  <input
                    class="doc-submit-inputs"
                    id="water-registry-document"
                    pInputText
                    type="text"
                    formControlName="drinking_water_registration" />
                </div>
                <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                  <p-fileUpload
                    #documentUploader13
                    chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                    (onSelect)="onSelectFile($event, documentTypes[12].value, documentUploader13, 'drinking_water_registration')"
                    mode="basic"></p-fileUpload>
                </div>
                <div class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align">
                  <!-- <i class="pi pi-info-circle hint-icon" *ngIf="infoBubblesData?.showWaterRegistryInfo"></i> -->
                </div>
              </div>
              <div *ngIf="allSampleDocuments?.drinking_water_registration" class="ui-g-12 sample-doc-link">
                <label class="ui-g-3"></label>
                <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
                <a
                  (click)="
                    downloadExampleDocument(
                      allSampleDocuments['drinking_water_registration'].document_id,
                      allSampleDocuments['drinking_water_registration'].filename
                    )
                  ">
                  {{ allSampleDocuments['drinking_water_registration'].name }}
                </a>
              </div>
            </ng-container>

            <ng-container *ngIf="documents.get('crane_con_with_electric_drive')">
              <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
                <label
                  class="ui-g-3 field-label text-right-align"
                  [class.required]="documents.get('crane_con_with_electric_drive').validator"
                  for="site-electricity-crane-connection-document">
                  {{ 'documents.site_electricity_crane_connection_document' | translate }}
                </label>
                <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                  <input
                    class="doc-submit-inputs"
                    id="site-electricity-crane-connection-document"
                    pInputText
                    type="text"
                    formControlName="crane_con_with_electric_drive" />
                </div>
                <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                  <p-fileUpload
                    #documentUploader14
                    chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                    (onSelect)="onSelectFile($event, documentTypes[15].value, documentUploader14, 'crane_con_with_electric_drive')"
                    mode="basic"></p-fileUpload>
                </div>
                <div class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align">
                  <!-- <i class="pi pi-info-circle hint-icon" *ngIf="infoBubblesData?.showCraneConWithElectricDriveInfo"></i> -->
                </div>
              </div>
              <div *ngIf="allSampleDocuments?.crane_con_with_electric_drive" class="ui-g-12 sample-doc-link">
                <label class="ui-g-3"></label>
                <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
                <a
                  (click)="
                    downloadExampleDocument(
                      allSampleDocuments['crane_con_with_electric_drive'].document_id,
                      allSampleDocuments['crane_con_with_electric_drive'].filename
                    )
                  ">
                  {{ allSampleDocuments['crane_con_with_electric_drive'].name }}
                </a>
              </div>
            </ng-container>

            <ng-container *ngIf="documents.get('inspection_sticker')">
              <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
                <label
                  class="ui-g-3 field-label text-right-align"
                  [class.required]="documents.get('inspection_sticker').validator"
                  for="inspection-sticker-document">
                  {{ 'documents.inspection_sticker_document' | translate }}
                </label>
                <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                  <input
                    class="doc-submit-inputs"
                    id="inspection-sticker-document"
                    pInputText
                    type="text"
                    formControlName="inspection_sticker" />
                </div>
                <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                  <p-fileUpload
                    #documentUploader15
                    chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                    (onSelect)="onSelectFile($event, documentTypes[15].value, documentUploader15, 'inspection_sticker')"
                    mode="basic"></p-fileUpload>
                </div>
                <div class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align">
                  <!-- <i class="pi pi-info-circle hint-icon" *ngIf="infoBubblesData?.showInspectionStickerInfo"></i> -->
                </div>
              </div>
              <div *ngIf="allSampleDocuments?.inspection_sticker" class="ui-g-12 sample-doc-link">
                <label class="ui-g-3"></label>
                <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
                <a
                  (click)="
                    downloadExampleDocument(
                      allSampleDocuments['inspection_sticker'].document_id,
                      allSampleDocuments['inspection_sticker'].filename
                    )
                  ">
                  {{ allSampleDocuments['inspection_sticker'].name }}
                </a>
              </div>
            </ng-container>

            <ng-container *ngIf="documents.get('proof_of_landowner')">
              <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
                <label
                  class="ui-g-3 field-label text-right-align"
                  [class.required]="documents.get('proof_of_landowner').validator"
                  for="proof-of-landowner-document">
                  {{ 'lookup.' + documentTypeKey + '.options.proof_of_landowner.name' | translate }}
                </label>
                <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                  <input
                    class="doc-submit-inputs"
                    id="proof-of-landowner-document"
                    pInputText
                    type="text"
                    formControlName="proof_of_landowner" />
                </div>
                <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                  <p-fileUpload
                    #documentUploaderProofOfLandowner
                    chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                    (onSelect)="onSelectFile($event, documentTypes[15].value, documentUploaderProofOfLandowner, 'proof_of_landowner')"
                    mode="basic"></p-fileUpload>
                </div>
                <div class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align">
                  <!-- <i class="pi pi-info-circle hint-icon" *ngIf="infoBubblesData?.showProofOfLandownerInfo"></i> -->
                </div>
              </div>
              <div *ngIf="allSampleDocuments?.proof_of_landowner" class="ui-g-12 sample-doc-link">
                <label class="ui-g-3"></label>
                <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
                <a
                  (click)="
                    downloadExampleDocument(
                      allSampleDocuments['proof_of_landowner'].document_id,
                      allSampleDocuments['proof_of_landowner'].filename
                    )
                  ">
                  {{ allSampleDocuments['proof_of_landowner'].name }}
                </a>
              </div>
            </ng-container>

            <ng-container *ngIf="documents.get('approval_empty_pipe')">
              <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
                <label
                  class="ui-g-3 field-label text-right-align"
                  [class.required]="documents.get('approval_empty_pipe').validator"
                  for="approval-empty-pipe-document">
                  {{ 'lookup.' + documentTypeKey + '.options.approval_empty_pipe.name' | translate }}
                </label>
                <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                  <input
                    class="doc-submit-inputs"
                    id="approval-empty-pipe-document"
                    pInputText
                    type="text"
                    formControlName="approval_empty_pipe" />
                </div>
                <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                  <p-fileUpload
                    #documentUploaderApprovalEmptyPipe
                    chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                    (onSelect)="onSelectFile($event, documentTypes[15].value, documentUploaderApprovalEmptyPipe, 'approval_empty_pipe')"
                    mode="basic"></p-fileUpload>
                </div>
                <div class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align">
                  <!-- <i class="pi pi-info-circle hint-icon" *ngIf="infoBubblesData?.showApprovalEmptyPipeInfo"></i> -->
                </div>
              </div>
              <div *ngIf="allSampleDocuments?.approval_empty_pipe" class="ui-g-12 sample-doc-link">
                <label class="ui-g-3"></label>
                <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
                <a
                  (click)="
                    downloadExampleDocument(
                      allSampleDocuments['approval_empty_pipe'].document_id,
                      allSampleDocuments['approval_empty_pipe'].filename
                    )
                  ">
                  {{ allSampleDocuments['approval_empty_pipe'].name }}
                </a>
              </div>
            </ng-container>

            <ng-container *ngIf="documents.get('current_account')">
              <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
                <label
                  class="ui-g-3 field-label text-right-align"
                  [class.required]="documents.get('current_account').validator"
                  for="current-account-document">
                  {{ 'lookup.' + documentTypeKey + '.options.current_account.name' | translate }}
                </label>
                <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                  <input class="doc-submit-inputs" id="current-account-document" pInputText type="text" formControlName="current_account" />
                </div>
                <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                  <p-fileUpload
                    #documentUploaderCurrentAccount
                    chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                    (onSelect)="onSelectFile($event, 'current_account', documentUploaderCurrentAccount, 'current_account')"
                    mode="basic"></p-fileUpload>
                </div>
                <div class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align">
                  <!-- <i class="pi pi-info-circle hint-icon" *ngIf="infoBubblesData?.showCurrentAccountInfo"></i> -->
                </div>
              </div>
              <div *ngIf="allSampleDocuments?.current_account" class="ui-g-12 sample-doc-link">
                <label class="ui-g-3"></label>
                <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
                <a
                  (click)="
                    downloadExampleDocument(
                      allSampleDocuments['current_account'].document_id,
                      allSampleDocuments['current_account'].filename
                    )
                  ">
                  {{ allSampleDocuments['current_account'].name }}
                </a>
              </div>
            </ng-container>
          </div>

          <div
            class="form-background top-bottom-margin"
            *ngIf="
              currentInstallationFlow === installationFlowType.ConversionToGas &&
              (showSitePlanDocumentForConversionToGas || showPlanWithEntryForConversionToGas)
            ">
            <div
              *ngIf="showSitePlanDocumentForConversionToGas && documents.get('site_plan')"
              class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
              <label
                class="ui-g-3 field-label text-right-align"
                [class.required]="documents.get('site_plan')?.validator"
                for="official-plan">
                {{ 'documents.official-plan' | translate }}
              </label>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                <input class="doc-submit-inputs" pInputText type="text" formControlName="site_plan" />
              </div>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                <p-fileUpload
                  #documentUploader8
                  chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                  (onSelect)="onSelectFile($event, documentTypes[0].value, documentUploader8, 'site_plan')"
                  mode="basic"></p-fileUpload>
              </div>
              <div
                class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align"
                *ngIf="infoBubblesData?.showSitePlanInfo">
                <!-- <i class="pi pi-info-circle hint-icon"></i> -->
              </div>
            </div>

            <div *ngIf="showPlanWithEntryForConversionToGas" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
              <label class="ui-g-3 field-label text-right-align" for="plan-with-entry">
                {{ 'documents.plan_with_entry' | translate }}
              </label>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                <input class="doc-submit-inputs" id="plan-with-entry" pInputText type="text" formControlName="floor_plan" />
              </div>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                <p-fileUpload
                  #documentUploader10
                  chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                  (onSelect)="onSelectFile($event, documentTypes[1].value, documentUploader10, 'floor_plan')"
                  mode="basic"></p-fileUpload>
              </div>
              <div
                class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align"
                *ngIf="infoBubblesData?.showFloorPlanInfo">
                <!-- <i class="pi pi-info-circle hint-icon"></i> -->
              </div>
            </div>
          </div>

          <div
            class="form-background top-bottom-margin"
            *ngIf="showExcerptOrOverviewPlanDocument && currentInstallationFlow === installationFlowType.ConversionToGas">
            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
              <label
                class="ui-g-3 field-label text-right-align"
                [class.required]="documents.get('excerpt_or_overview_plan')?.validator"
                for="excerpt-or-overview-plan">
                {{ 'documents.excerpt-or-overview-plan' | translate }}
              </label>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                <input
                  class="doc-submit-inputs"
                  id="excerpt-or-overview-plan"
                  pInputText
                  type="text"
                  formControlName="excerpt_or_overview_plan" />
              </div>
              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                <p-fileUpload
                  #documentUploaderExcerptOrOverviewPlan
                  chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                  (onSelect)="
                    onSelectFile($event, documentTypes[14].value, documentUploaderExcerptOrOverviewPlan, 'excerpt_or_overview_plan')
                  "
                  mode="basic"></p-fileUpload>
              </div>
            </div>
            <div
              *ngIf="
                (currentInstallationFlow === installationFlowType.MainsConnection ||
                  currentInstallationFlow === installationFlowType.ChangeHouseConnection) &&
                allSampleDocuments?.floor_plan
              "
              class="ui-g-12 sample-doc-link">
              <label class="ui-g-3"></label>
              <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
              <a
                (click)="
                  downloadExampleDocument(
                    allSampleDocuments['excerpt_or_overview_plan'].document_id,
                    allSampleDocuments['excerpt_or_overview_plan'].filename
                  )
                ">
                {{ allSampleDocuments['excerpt_or_overview_plan'].name }}
              </a>
            </div>
          </div>

          <div *ngFor="let item of items?.controls; let i = index" class="form-background top-bottom-margin flex-row" formArrayName="items">
            <div [formGroupName]="i" class="ui-g-8 ui-xl-8 ui-lg-8 ui-md-10 ui-sm-10 ui-xs-10">
              <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
                <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
                  <input class="doc-submit-inputs" formControlName="documentName" pInputText type="text" />
                </div>
                <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                  <p-fileUpload
                    #documentUploader
                    (onSelect)="onImageUpload($event, i, documentUploader)"
                    chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                    mode="basic"></p-fileUpload>
                </div>
                <div class="ui-g-1 ui-xl-1 ui-lg-1 ui-md-12 ui-sm-12 ui-xs-12 zero-padding text-right-align">
                  <!-- <i class="pi pi-info-circle hint-icon" *ngIf="infoBubblesData?.showOtherDocumentInfo"></i> -->
                </div>
              </div>
            </div>

            <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-2 ui-sm-2 ui-xs-2 field-rows file-name-section">
              <a *ngIf="item.value['fileName']" href="javascript:void(0)" (click)="downloadDocument(i, item.value['fileName'])">
                {{ item.value['fileName'] }}
              </a>
              <i (click)="removeDocument(i)" class="pi pi-trash pointer-cursor delete-icon"></i>
            </div>
          </div>
          <div class="hint-text" *ngIf="showNoteFindRelevantDocsChecklist && currentInstallationFlow === installationFlowType.FeedInSystem">
            {{ 'documents.find-document-checklist' | translate }}
          </div>
          <div class="hint-text" *ngIf="showNoteUploadAltMeasurementDoc">
            {{ 'documents.upload-alternative-measurement-document' | translate }}
          </div>
          <div *ngIf="currentInstallationFlow === installationFlowType.FeedInSystem && showNoteIfStorageIsSelected" class="hint-text">
            {{ 'documents.note-if-storage-is-selected' | translate }}
          </div>
          <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12">
            <div class="ui-g-12 margin-align add-button-row form-font-size">
              <i (click)="addDocuments(true)" class="pi pi-plus plus-icon new-facility-plus-icon" id="base-data-add-facility"></i>
              <label class="ui-g-5 field-label" for="base-data-add-facility">
                {{ 'facilities-data.form-fields.add-document-button' | translate }}
              </label>
            </div>
          </div>
          <div class="ordnance-warning" *ngIf="showHelpText">
            <i class="pi pi-exclamation-circle info-icon"></i>
            <span [innerHTML]="'documents.help-text' | translate"></span>
          </div>
          <div
            class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 comment-section"
            *ngIf="
              currentInstallationFlow === installationFlowType.FeedInSystem ||
              currentInstallationFlow === installationFlowType.MainsConnection ||
              currentInstallationFlow === installationFlowType.TemporaryConnection ||
              currentInstallationFlow === installationFlowType.ChangeHouseConnection ||
              currentInstallationFlow === installationFlowType.ConversionToGas ||
              showCommentField
            ">
            <div class="ui-g-12 comment-section-title">{{ 'documents.comment' | translate }}</div>
            <ng-container *ngIf="environmentService.showWordFormat && documents.get('comments')">
              <quill-editor
                [styles]="editorStyle"
                placeholder="Enter Text"
                formControlName="comments"
                [modules]="quillConfig"></quill-editor>
            </ng-container>
            <ng-container *ngIf="!environmentService.showWordFormat && documents.get('comments')">
              <textarea rows="10" class="ui-g-12" formControlName="comments"></textarea>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
        <app-section-header
          [title]="'basic-profile.jurisdiction.inquiry' | translate"
          [tooltip]="'tooltips.documents-submission.jurisdiction.inquiry' | translate"></app-section-header>
        <div
          *ngIf="
            showConnectionDateSelector || (currentInstallationFlow === installationFlowType.TemporaryConnection && !showInquiryDesiredDate)
          "
          class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 top-margin">
          <div class="ui-g-5 ui-xl-5 ui-lg-5 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
            <label class="ui-g-3 field-label text-right-align margin-right-align" for="doc-sub-des-date">
              {{ 'documents.building_conn_date' | translate }}
            </label>
            <p-calendar
              *ngIf="'app.calendar-settings' | translate"
              [(ngModel)]="connectionDate"
              [dateFormat]="dateFormat.dateFormat"
              [monthNavigator]="true"
              [locale]="'app.calendar-settings' | translate"
              [placeholder]="dateFormat.placeholder"
              [yearNavigator]="true"
              class="doc-submit-datepicker ui-g-7"
              dataType="string"
              id="building-conn-date"
              inputId="basic"
              [minDate]="minBuildingConDate"
              yearRange="1900:2080"></p-calendar>
            <div
              *ngIf="
                showWorksBeginsAfterOfferLable &&
                (currentInstallationFlow === installationFlowType.MainsConnection ||
                  currentInstallationFlow === installationFlowType.ConversionToGas)
              ">
              {{ 'documents.works-begins-14-weeks-after-offer' | translate }}
            </div>
          </div>
        </div>
        <div
          class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows top-margin"
          *ngIf="
            currentInstallationFlow !== installationFlowType.TemporaryConnection ||
            (currentInstallationFlow === installationFlowType.TemporaryConnection && showInquiryDesiredDate)
          ">
          <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-right-align">
            <label class="ui-g-4 field-label text-right-align margin-right-align" for="doc-sub-des-date">
              {{ 'facilities-data.form-fields.des_date' | translate }}
            </label>
            <p-calendar
              *ngIf="'app.calendar-settings' | translate"
              [(ngModel)]="selectedDate"
              [dateFormat]="dateFormat?.dateFormat"
              [monthNavigator]="true"
              [locale]="'app.calendar-settings' | translate"
              [placeholder]="dateFormat?.placeholder"
              [yearNavigator]="true"
              class="doc-submit-datepicker ui-g-7"
              dataType="string"
              id="doc-sub-des-date"
              inputId="basic"
              [minDate]="minDate"
              [defaultDate]="minDate"
              yearRange="1900:2080"></p-calendar>
          </div>
          <div
            *ngIf="
              showWorksBeginsAfterOfferLable &&
              (currentInstallationFlow === installationFlowType.MainsConnection ||
                currentInstallationFlow === installationFlowType.ConversionToGas)
            ">
            {{ 'documents.works-begins-14-weeks-after-offer' | translate }}
          </div>
          <div class="ui-g-1">
            <i
              class="pi pi-info-circle hint-icon"
              *ngIf="infoBubblesData?.showInquiryInfo"
              tooltipStyleClass="netz-info-tooltip"
              pTooltip="{{
                (showDesiredDateOperationInfo ? 'documents.desired-date-operation-info' : 'documents.desired-date-inquiry') | translate
              }}"></i>
          </div>
          <div
            class="ui-g-5 ui-xl-5 ui-lg-5 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align chimney-container"
            [formGroup]="documents"
            *ngIf="documents?.get('chimneySweep')">
            <label
              class="ui-g-4 field-label text-right-align margin"
              [class.required]="documents?.get('chimneySweep')"
              for="chimney-sweeper">
              {{ 'documents.chimney_sweepers' | translate }}
            </label>
            <p-dropdown
              [options]="chimneySweeperOptions"
              [(ngModel)]="chimneySweeper"
              formControlName="chimneySweep"
              id="chimney-sweeper"
              placeholder="-Select-"
              optionLabel="name"
              optionValue="chimney_sweeper_id"></p-dropdown>
          </div>
        </div>
        <div
          class="p-field-checkbox align-label"
          *ngIf="
            showCorrectnessOfInformationCheckbox &&
            (currentInstallationFlow === installationFlowType.MainsConnection ||
              currentInstallationFlow === installationFlowType.ConversionToGas)
          ">
          <p-checkbox
            binary="true"
            inputId="binary"
            [(ngModel)]="correctnessOfInformationCheckbox"
            (onChange)="checkValidityForSubmitButton()"></p-checkbox>
          <label class="required">{{ 'documents.correctness-of-information' | translate }}</label>
        </div>

        <div
          class="mains-connection-approval-section ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
          *ngIf="currentInstallationFlow === installationFlowType.MainsConnection && showMainsConnectionApproval">
          <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 top-bottom-margin">
            <h3 *ngIf="role === 'customer'; else technicianGuestTechnicianHeader">
              {{ 'documents.prerequisites-for-completing.headline' | translate }}
            </h3>
            <ng-template #technicianGuestTechnicianHeader>
              <h3>{{ 'documents.prerequisites-for-completing.technician-guest-technician-headline' | translate }}</h3>
            </ng-template>
            <div *ngIf="role === 'customer'; else technicianGuestTechnicianCondition" class="p-field-checkbox align-label">
              <p-checkbox
                binary="true"
                inputId="binary"
                [(ngModel)]="gridConnectionContractCheckbox"
                (onChange)="checkValidityForSubmitButton()"></p-checkbox>
              <label class="required">{{ 'documents.prerequisites-for-completing.condition-1' | translate }}</label>
            </div>
            <ng-template #technicianGuestTechnicianCondition>
              <div class="p-field-checkbox align-label">
                <p-checkbox
                  binary="true"
                  inputId="binary"
                  [(ngModel)]="isVerifiedByTechnician"
                  (onChange)="checkValidityForSubmitButton()"></p-checkbox>
                <label class="required">
                  {{ 'documents.prerequisites-for-completing.technician-guest-technician-condition-1' | translate }}
                </label>
              </div>
            </ng-template>
            <ng-container *ngIf="role === 'customer'">
              <div class="p-field-checkbox align-label">
                <p-checkbox
                  binary="true"
                  inputId="binary"
                  [(ngModel)]="buildingIsClosedCheckbox"
                  (onChange)="checkValidityForSubmitButton()"></p-checkbox>
                <label class="required">{{ 'documents.prerequisites-for-completing.condition-2' | translate }}</label>
              </div>
              <div class="p-field-checkbox align-label">
                <p-checkbox
                  binary="true"
                  inputId="binary"
                  [(ngModel)]="freedomToBuildCheckbox"
                  (onChange)="checkValidityForSubmitButton()"></p-checkbox>
                <label class="required">{{ 'documents.prerequisites-for-completing.condition-3' | translate }}</label>
              </div>
              <div class="p-field-checkbox align-label">
                <p-checkbox
                  binary="true"
                  inputId="binary"
                  [(ngModel)]="sewageAndRainwaterClosureCheckbox"
                  (onChange)="checkValidityForSubmitButton()"></p-checkbox>
                <label class="required">{{ 'documents.prerequisites-for-completing.condition-4' | translate }}</label>
              </div>
              <div class="p-field-checkbox align-label">
                <p-checkbox
                  binary="true"
                  inputId="binary"
                  [(ngModel)]="houseEntriesCheckbox"
                  (onChange)="checkValidityForSubmitButton()"></p-checkbox>
                <label class="required">{{ 'documents.prerequisites-for-completing.condition-5' | translate }}</label>
              </div>
            </ng-container>
          </div>
        </div>

        <div
          class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 top-bottom-margin"
          *ngIf="
            isHeatingFacilityAvailable &&
            currentInstallationFlow === installationFlowType.MainsConnection &&
            showDistrictHeatingRegulationsCheckbox
          ">
          <div class="p-field-checkbox align-label">
            <p-checkbox
              binary="true"
              inputId="binary"
              [(ngModel)]="districtHeatingRegulationsChecked"
              (onChange)="checkValidityForSubmitButton()"></p-checkbox>
            <label class="required">{{ 'documents.terms-for-heating.condition-3' | translate }}</label>
          </div>
        </div>

        <div
          class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 top-bottom-margin"
          *ngIf="
            isPowerFacilityAvailable &&
            (currentInstallationFlow === installationFlowType.NewInstallation ||
              (currentInstallationFlow === installationFlowType.UpdateInstallation && showPowerTermsChecked) ||
              currentInstallationFlow === installationFlowType.SiteElectricityMeterdata)
          ">
          <div class="p-field-checkbox">
            <p-checkbox
              binary="true"
              inputId="binary"
              [(ngModel)]="powerTermsChecked"
              (onChange)="checkValidityForSubmitButton()"></p-checkbox>
            <label>{{ 'documents.terms-for-power' | translate }}</label>
          </div>
        </div>
        <div
          class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 top-bottom-margin"
          *ngIf="
            isAllMediaFacilityAvailable &&
            (currentInstallationFlow === installationFlowType.MainsConnection ||
              currentInstallationFlow === installationFlowType.ChangeHouseConnection) &&
            showTechnicalConditionsMetCheckbox
          ">
          <div class="p-field-checkbox">
            <p-checkbox
              binary="true"
              inputId="binary"
              [(ngModel)]="technicalConditionsMetCheckbox"
              (onChange)="checkValidityForSubmitButton()"></p-checkbox>
            <label>{{ 'documents.terms-for-all-media' | translate }}</label>
          </div>
        </div>
        <div
          class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 top-bottom-margin"
          *ngIf="currentInstallationFlow === installationFlowType.MainsConnection && showAcceptOfferCheckbox">
          <div class="p-field-checkbox">
            <p-checkbox
              binary="true"
              inputId="binary"
              [(ngModel)]="acceptOfferCheckbox"
              (onChange)="checkValidityForSubmitButton()"></p-checkbox>
            <label>{{ 'documents.accept-offer-agreement' | translate }}</label>
          </div>
        </div>
        <div
          class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 top-bottom-margin"
          *ngIf="
            isGasFacilityAvailable &&
            (currentInstallationFlow === installationFlowType.NewInstallation ||
              currentInstallationFlow === installationFlowType.UpdateInstallation)
          ">
          <div class="p-field-checkbox">
            <p-checkbox
              binary="true"
              inputId="binary"
              [(ngModel)]="gasTermsChecked1"
              (onChange)="checkValidityForSubmitButton()"></p-checkbox>
            <label>{{ 'documents.terms-for-gas1' | translate }}</label>
          </div>
          <div class="p-field-checkbox">
            <p-checkbox
              binary="true"
              inputId="binary"
              [(ngModel)]="gasTermsChecked2"
              (onChange)="checkValidityForSubmitButton()"></p-checkbox>
            <label>{{ 'documents.terms-for-gas2' | translate }}</label>
          </div>
          <div class="p-field-checkbox" *ngIf="environmentService.showGas3">
            <p-checkbox
              binary="true"
              inputId="binary"
              [(ngModel)]="gasTermsChecked3"
              (onChange)="checkValidityForSubmitButton()"></p-checkbox>
            <label>
              <b>{{ 'documents.terms-for-gas3' | translate }}</b>
            </label>
          </div>
        </div>
        <div
          class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 top-bottom-margin"
          *ngIf="isWaterFacilityAvailable && currentInstallationFlow === installationFlowType.NewInstallation">
          <div class="p-field-checkbox">
            <p-checkbox
              binary="true"
              inputId="binary"
              [(ngModel)]="waterTermsChecked"
              (onChange)="checkValidityForSubmitButton()"></p-checkbox>
            <label class="terms-labels">
              {{ 'documents.condition-start' | translate }}
              <ul>
                <li>{{ 'documents.terms-for-water.condition-1' | translate }}</li>
                <li>{{ 'documents.terms-for-water.condition-2' | translate }}</li>
                <li>{{ 'documents.terms-for-water.condition-3' | translate }}</li>
                <li>{{ 'documents.terms-for-water.condition-4' | translate }}</li>
              </ul>
            </label>
          </div>
        </div>
        <div
          class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 top-bottom-margin"
          *ngIf="isHeatingFacilityAvailable && currentInstallationFlow === installationFlowType.NewInstallation">
          <div class="p-field-checkbox">
            <p-checkbox
              binary="true"
              inputId="binary"
              [(ngModel)]="heatingTermsChecked"
              (onChange)="checkValidityForSubmitButton()"></p-checkbox>
            <label class="terms-labels">
              <ul>
                <li>{{ 'documents.terms-for-heating.condition-1' | translate }}</li>
                <li>{{ 'documents.terms-for-heating.condition-2' | translate }}</li>
              </ul>
            </label>
          </div>
        </div>

        <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" [formGroup]="documents" *ngIf="documents">
          <div
            class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 comment-section"
            *ngIf="showInstallationComment && documents?.get('installationComment')">
            <div class="ui-g-12 comment-section-title">{{ 'documents.additional-comment' | translate }}</div>
            <ng-container *ngIf="environmentService.showWordFormat">
              <quill-editor
                [styles]="editorStyle"
                placeholder="Enter Text"
                formControlName="installationComment"
                [modules]="quillConfig"></quill-editor>
            </ng-container>
            <ng-container *ngIf="!environmentService.showWordFormat">
              <textarea rows="10" class="ui-g-12" formControlName="installationComment"></textarea>
            </ng-container>
          </div>
        </div>
        <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 top-margin submit-button-section">
          <div class="add-more-prod" *ngIf="showAddMoreProductsButton">
            <i
              class="pi pi-shopping-cart add-more-prod-icon"
              [ngClass]="isSubmitDisabled ? 'add-more-prod-icon-disabled' : ''"
              pTooltip="{{ 'documents.add-more-prod' | translate }}"
              (click)="redirectToProducts()"></i>
          </div>
          <button
            (click)="submitFormData(false)"
            class="submit-button text-uppercase"
            label="{{ 'basic-profile.fields.send_request' | translate }}"
            pButton
            [disabled]="isSubmitDisabled"
            type="button"></button>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="environmentService.isDecommissioningOfGridConnection && currentSelectionType === 'shutdown'">
  <div>
    <p class="submit-success-text">
      {{ 'submitted.no_document_needed' | translate }}
    </p>
  </div>
  <div
    class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 top-margin"
    [ngClass]="
      environmentService.isDecommissioningOfGridConnection && currentSelectionType === 'shutdown'
        ? 'submit-button-decommission'
        : 'submit-button-section'
    ">
    <button
      (click)="submitFormData(false)"
      class="submit-button text-uppercase"
      label="{{ 'basic-profile.fields.send_request' | translate }}"
      pButton
      type="button"></button>
  </div>
</ng-container>
<app-loader *ngIf="isLoading"></app-loader>
